import { atom } from 'jotai'
import { PaymentLinkStep } from 'types/payments'

export const paymentLinkStepAtom = atom<PaymentLinkStep>(PaymentLinkStep.CONTACT)
export const paymentLinkUrlAtom = atom('')
